/** Use `throw unreachable(value)` to require an exhaustive branch and retain unexpected runtime input. */
export function unreachable(value: never): Error {
	return new Error('Unreachable value', { cause: value });
}
